import { Check } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "../Reveal";

const POINTS = [
  "STOCKBOX 8 trouve sa place dans un utilitaire",
  "Plusieurs boîtes empilées et organisées",
  "Accès rapide aux petites pièces sur chantier",
  "Suivi du stock depuis l'application",
];

export default function Vehicle() {
  return (
    <section id="vehicule" className="py-16 sm:py-24" data-testid="vehicle-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <div className="relative border border-[#2E333D] rounded-2xl overflow-hidden" data-testid="vehicle-image-frame">
            <img
              src="https://images.unsplash.com/photo-1782970795057-b219e667ad00?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxwbHVtYmVyJTIwZWxlY3RyaWNpYW4lMjB0ZWNobmljaWFuJTIwdG9vbHMlMjB2YW58ZW58MHx8fHwxNzkwNzEyNDQ3fDA&ixlib=rb-4.1.0&q=85"
              alt="Véhicule utilitaire de professionnel équipé pour le rangement d'outillage et de consommables"
              className="w-full h-72 sm:h-96 object-cover"
              loading="lazy"
              data-testid="vehicle-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0C0D0E]/90 via-transparent to-transparent" />
            <p className="absolute bottom-4 left-4 font-mono text-[10px] uppercase tracking-widest text-gray-400">Concept d'usage — aménagement non définitif</p>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <Eyebrow>Dans votre véhicule</Eyebrow>
          <SectionTitle>Votre stock vous accompagne partout.</SectionTitle>
          <p className="mt-6 text-gray-400 leading-relaxed max-w-lg">
            Le concept STOCKBOX 8 est pensé pour vivre dans votre véhicule professionnel :
            vos pièces restent organisées, et leur niveau estimé vous suit où que vous alliez.
          </p>
          <ul className="mt-8 space-y-3">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3 text-sm text-gray-300">
                <Check size={16} className="text-[#FFC700] mt-0.5 shrink-0" /> {p}
              </li>
            ))}
          </ul>
          <p className="mt-6 text-xs text-gray-500 max-w-lg">
            L'installation définitive dans tous les types de véhicules n'est pas encore validée —
            elle fait partie des points étudiés pendant le développement.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
